import axios from './axios';
import { Survey } from '../types';

interface SurveyData {
  text: string;
  order: number;
  input_type: 'radio' | 'textarea';
}

/**
 * アンケート一覧を取得
 */
export const getSurveys = async (): Promise<Survey[]> => {
  const response = await axios.get('/admin/surveys');
  return response.data;
};

/**
 * 指定されたアンケートを取得
 */
export const getSurvey = async (id: number): Promise<Survey> => {
  const response = await axios.get(`/admin/surveys/${id}`);
  return response.data;
};

/**
 * 新しいアンケートを作成
 */
export const createSurvey = async (data: SurveyData): Promise<Survey> => {
  const response = await axios.post('/admin/surveys', data);
  return response.data;
};

/**
 * アンケートを更新
 */
export const updateSurvey = async (id: number, data: SurveyData): Promise<Survey> => {
  const response = await axios.put(`/admin/surveys/${id}`, data);
  return response.data;
};

/**
 * アンケートを削除
 */
export const deleteSurvey = async (id: number): Promise<void> => {
  await axios.delete(`/admin/surveys/${id}`);
};
